import RoleRepository from '../../repositories/RoleRepository';
// import TranslatorServerRepository from '../../repositories/TranslatorServerRepository'
// import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		// state remains local to component
	},
	mutations: {
		// no mutations as state remains local to components
	},
	actions: {
		fetchPermissions ({ getters }) {
			return RoleRepository.getPermissions();
		},
		fetchRoles ({ getters }) {
			return RoleRepository.getRoles();
		},
		storeRole ({ getters }, form) {
			return RoleRepository.createRole(form);
		},
		updateRole ({ getters }, form) {
			return RoleRepository.editRole(form);
		},
		removeRole ({ getters }, role) {
			return RoleRepository.deleteRole(role.id);
		}
	},
	getters: {
	}
};
